<template>
	<div class="testdrive" :style="{height: height}">
		<div class="inner">
			<div class="title">Будь на пике формы во всех сферах жизни</div>
			<div class="nav">
				<router-link
					v-for="(page, index) in pages"
					:key="index"
					:to="'/' + page"
					:class="page"
					@click="linkClick(page)"
				>{{ names[page] }}</router-link>
			</div>

			<a
				:href="link"
				target="_blank"
				class="testdrive-btn"
				@click="linkClick('testdrive')"
			>Записаться на тест-драйв</a>
		</div>
		<div class="legal">
			<a href="/rules1.pdf" target="_blank">
				<img src="@/assets/images/footer_icon1.png">
				Правила рассылки
				<br>сообщений
			</a>
			<a href="/rules2.pdf" target="_blank">
				<img src="@/assets/images/footer_icon2.png">
				Положение об обработке
				<br>персональнх данныx
			</a>
			<a href="/rules3.pdf" target="_blank">
				<img src="@/assets/images/footer_icon3.png">
				Согласние на обработку
				<br>персональнх данныx
			</a>
			<a href="/rules4.pdf" target="_blank">
				<img src="@/assets/images/footer_icon4.png">
				Условия и способы обработки
				<br>и хранения персональных данных
			</a>
		</div>
	</div>
</template>


<script>
import Events from '@/events'
import shareMixin from '@/mixins/shares'

const LINKS = {
	sport:
		'https://www.kia.ru/request/order_testdrive/?model=sportage/?utm_source=special_project&utm_medium=banner&utm_content=sport&utm_campaign=KIA_Sportage_Tactic_December_2018',
	career:
		'https://www.kia.ru/request/order_testdrive/?model=sportage/?utm_source=special_project&utm_medium=banner&utm_content=career&utm_campaign=KIA_Sportage_Tactic_December_2018',
	family:
		'https://www.kia.ru/request/order_testdrive/?model=sportage/?utm_source=special_project&utm_medium=banner&utm_content=family&utm_campaign=KIA_Sportage_Tactic_December_2018',
	business:
		'https://www.kia.ru/request/order_testdrive/?model=sportage/?utm_source=special_project&utm_medium=banner&utm_content=business&utm_campaign=KIA_Sportage_Tactic_December_2018',
	art:
		'https://www.kia.ru/request/order_testdrive/?model=sportage/?utm_source=special_project&utm_medium=banner&utm_content=art&utm_campaign=KIA_Sportage_Tactic_December_2018',
}

export default {
	name: 'TestDrive',
	mixins: [shareMixin],
	props: {
		page: String,
		color: String,
	},
	data() {
		return {
			height: '965px',
			names: {
				sport: 'Спорт',
				career: 'Карьера',
				family: 'Семья',
				business: 'Бизнес',
				art: 'Творчество',
			},
		}
	},
	computed: {
		pages() {
			let all = ['sport', 'career', 'family', 'business', 'art']
			return all.filter(p => p !== this.page)
		},
		link() {
			return LINKS[this.page]
		},
	},
	mounted() {
		window.mainView = document.getElementById('view')
		window.addEventListener('resize', this.calcFooter)
		this.calcFooter()
	},
	destroyed() {
		window.removeEventListener('resize', this.calcFooter)
	},
	methods: {
		calcFooter() {
			let width = window.innerWidth
			let res = Math.floor(width / 1.989)
			if (width < 736) res = 600
			this.height = res + 'px'
		},
	},
}
</script>


<style lang="less" scoped>
@import "../styles/variables";

.testdrive {
	width: 100%;
	height: 600px;
	background-image: url(../assets/images/testdrive-bg.jpg);
	background-size: cover;
	background-position: center bottom;
}

.inner {
	position: relative;
	display: flex;
	flex-direction: column;
	width: 96%;
	height: 100%;
	max-width: 1200px;
	margin: 0 auto;
}

.title {
	font-size: 37px;
	text-align: center;
	color: #000;
	font-weight: bold;
	text-transform: uppercase;
}

.nav {
	width: 100%;
	margin-top: 40px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media (max-width: 1000px) {
		flex-direction: column;
	}

	@media (max-width: 667px) {
		flex-direction: column;
	}

	a {
		margin: 0 10px;
		padding: 15px 80px;
		font-size: 16px;
		letter-spacing: 4px;
		text-transform: uppercase;
		position: relative;
		transition: all 300ms ease;
		color: #000;
		border: 1px solid #000;
		text-align: center;

		@media (max-width: 1000px) {
			width: 300px;
			margin-bottom: 10px;
			padding: 15px 0;
			background: #fff;
			border: 1px solid #fff;
		}
	}

	a.business:hover {
		color: #fff;
		background: #2c2d2f;
		border: 1px solid #2c2d2f;
	}
	a.career:hover {
		color: #fff;
		background: #b67e5c;
		border: 1px solid #b67e5c;
	}
	a.family:hover {
		color: #fff;
		background: #25468d;
		border: 1px solid #25468d;
	}
	a.sport:hover {
		color: #fff;
		background: #c21734;
		border: 1px solid #c21734;
	}
	a.art:hover {
		color: #fff;
		background: #ed5224;
		border: 1px solid #ed5224;
	}
}

.testdrive-btn {
	width: 360px;
	color: #000;
	background: #fff;
	padding: 30px 0;
	display: block;
	transition: all 300ms ease;
	text-transform: uppercase;
	font-size: 14px;
	letter-spacing: 4px;
	text-align: center;
	position: absolute;
	top: 50%;
	left: 10px;

	@media (max-width: 1000px) {
		width: 100%;
		max-width: 400px;
		position: relative;
		top: 0%;
		left: 0px;
		margin: 0 auto;
		margin-top: 0px;
	}
}

.testdrive-btn:hover {
	background: #000;
	color: #fff;
}

.legal {
	position: absolute;
	display: flex;
	align-items: center;
	bottom: 20px;
	left: 20px;

	a {
		display: flex;
		color: #fff;
		font-size: 10px;
		text-decoration: underline;
		margin-right: 30px;
		opacity: 0.5;

		img {
			margin-right: 10px;
			height: 30px;
		}
	}

	@media (max-width: 1000px) {
		align-items: flex-start;
		a {
			width: 25%;
			margin: 0;

			img {
				display: none;
			}
		}
	}
}
</style>
